import type { ReactNode } from 'react';
import { useMemo } from 'react';

import { useRouteLoaderData } from '@remix-run/react';
import type { SocialsData, TSocialsElement } from '@shared/dream-components';
import { SocialsElement } from '@shared/dream-components';

import type { Publication } from '~/interfaces/publication';
import type { RootLoaderData } from '~/root';

interface Props {
  node: TSocialsElement;
  children: ReactNode | ReactNode[];
}

const Socials = ({ node, children }: Props) => {
  const { site } = useRouteLoaderData('root') as RootLoaderData;

  const nodeWithData = useMemo(() => {
    const nodeData = Object.keys(node?.attrs?.data || {}).reduce((accumulator: SocialsData, socialKey: string) => {
      const publicationValue = site.publication[socialKey as keyof Publication];
      const placeholderValue = node?.attrs?.data?.[socialKey as keyof SocialsData];

      // Only replace if publication has a non-empty value, otherwise keep placeholder
      accumulator[socialKey as keyof SocialsData] = publicationValue ? publicationValue : placeholderValue;
      return accumulator;
    }, {});

    return {
      ...node,
      attrs: {
        ...node.attrs,
        data: nodeData,
      },
    };
  }, [node, site.publication]);

  return (
    <SocialsElement isLive element={nodeWithData}>
      {children}
    </SocialsElement>
  );
};

export default Socials;
